import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

const YOUTUBE_ID = 'zYeOv1dd3Yc';
const TITLE = 'The "Forever Young" Ferrari SF90 Spider';

const FilmPage = () => {
  useDocumentMeta({
    title: `${TITLE} | Revs Tales`,
    description: 'A short film by Revs Vibes.',
    canonical: 'https://www.revsvibes.com/tales/the-forever-young-ferrari-sf90-spider',
    image: `https://i.ytimg.com/vi/${YOUTUBE_ID}/maxresdefault.jpg`,
  });

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#0a0a0a',
        color: '#fff',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      }}
      data-testid="film-page"
    >
      {/* Back link */}
      <Link
        to="/blog"
        style={{
          position: 'fixed', top: 20, left: 24, zIndex: 50,
          display: 'flex', alignItems: 'center', gap: 4,
          fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase',
          color: 'rgba(255,255,255,0.35)', textDecoration: 'none',
          transition: 'color 0.2s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.7)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.35)'; }}
        data-testid="film-back-link"
      >
        <ChevronLeft size={12} />
        Revs Tales
      </Link>

      {/* Hero — YouTube embed */}
      <div style={{
        width: '100%',
        maxWidth: 1120,
        margin: '0 auto',
        paddingTop: 72,
        paddingLeft: 20,
        paddingRight: 20,
      }}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%', /* 16:9 */
            background: '#000',
            borderRadius: 2,
            overflow: 'hidden',
          }}
          data-testid="film-embed-container"
        >
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${YOUTUBE_ID}?rel=0&modestbranding=1`}
            title={TITLE}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0, left: 0,
              width: '100%', height: '100%',
              border: 'none',
            }}
            data-testid="film-youtube-iframe"
          />
        </div>
      </div>

      {/* Title + subtitle */}
      <div style={{
        maxWidth: 720,
        margin: '0 auto',
        padding: '48px 20px 0',
      }}>
        <p style={{
          fontSize: 10,
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          color: 'rgba(255,255,255,0.3)',
          marginBottom: 16,
          fontWeight: 500,
        }}
          data-testid="film-label"
        >
          Revs Tales
        </p>
        <h1
          style={{
            fontSize: 'clamp(24px, 4vw, 40px)',
            fontWeight: 600,
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            color: '#fff',
            margin: 0,
          }}
          data-testid="film-title"
        >
          {TITLE}
        </h1>
        <p style={{
          fontSize: 14,
          fontWeight: 400,
          color: 'rgba(255,255,255,0.4)',
          marginTop: 20,
          fontStyle: 'italic',
          letterSpacing: '0.02em',
        }}
          data-testid="film-subtitle"
        >
          A short film.
        </p>
      </div>

      {/* Spacer to bottom */}
      <div style={{ height: 120 }} />
    </div>
  );
};

export default FilmPage;
